import { useState, useEffect, useRef } from "react";
import { N8N_BASE, FF, GF, Lbl, SPill, PR, GlassCard, INP, SEL, fmt, TabBar, SkeletonRows, StatCard } from "../shared";

const GET_CAMPAIGNS_URL = `${N8N_BASE}/qc-campaigns-get`;
const CREATE_URL        = `${N8N_BASE}/qc-campaign-create`;
const UPDATE_URL        = `${N8N_BASE}/qc-campaign-update`;

const PLATFORMS         = ["Instagram", "TikTok", "Instagram, TikTok", "YouTube"];
const TYPES             = ["one-off", "long-term"];
const PAYMENT_SCHEDULES = ["one-time", "split-payment"];
const STATUSES          = ["active", "awaiting_payment", "completed"];

const EMPTY_FORM = {
  campaign_name: "", brand: "", start_date: "", end_date: "",
  deal_amount: "", type: "one-off", payment_schedual: "one-time",
  platform: "Instagram", deliverables: "", notes: "",
  status: "active", linked_invoices: "", billed_to: "platform", num_invoices: "",
};


// ── Campaign form body (shared between New + Edit) ────────────────────────────
function FormBody({ form, setForm, mode, statusMsg, loading, onSubmit }) {
  const gross      = Number(form.deal_amount) || 0;
  const numInv     = Number(form.num_invoices) || 0;
  const showPreview = gross > 0 && numInv > 0;
  const netC       = form.billed_to === "platform" ? gross * 0.8 : gross;
  const netPer     = numInv > 0 ? netC / numInv : 0;
  const totalPer   = netPer * 1.13;

  const subPanel = {
    background: "rgba(255,255,255,0.45)",
    border: "0.5px solid rgba(255,255,255,0.78)",
  };

  return (
    <>
      <div className="form-grid-2">
        <GF label="Campaign Name" required>
          <input className="g-input" style={INP} value={form.campaign_name}
            onChange={(e) => setForm({ ...form, campaign_name: e.target.value })}
            placeholder="e.g. Lululemon Q3 2026" />
        </GF>
        <GF label="Brand" required>
          <input className="g-input" style={INP} value={form.brand}
            onChange={(e) => setForm({ ...form, brand: e.target.value })}
            placeholder="e.g. Lululemon" />
        </GF>
        <GF label="Deal Amount (CAD)" required>
          <input className="g-input" style={INP} type="number" value={form.deal_amount}
            onChange={(e) => setForm({ ...form, deal_amount: e.target.value })}
            placeholder="10 000" />
        </GF>
        <GF label="Number of Invoices">
          <input className="g-input" style={INP} type="number" value={form.num_invoices || ""}
            onChange={(e) => setForm({ ...form, num_invoices: e.target.value })}
            placeholder="e.g. 2" min="0" />
        </GF>
        <GF label="Billed To">
          <select className="g-select" style={SEL} value={form.billed_to}
            onChange={(e) => setForm({ ...form, billed_to: e.target.value })}>
            <option value="platform">Platform Media · 20% fee</option>
            <option value="direct">Direct · no fee</option>
          </select>
        </GF>
        <GF label="Platform">
          <select className="g-select" style={SEL} value={form.platform}
            onChange={(e) => setForm({ ...form, platform: e.target.value })}>
            {PLATFORMS.map((p) => <option key={p}>{p}</option>)}
          </select>
        </GF>
        <GF label="Type">
          <select className="g-select" style={SEL} value={form.type}
            onChange={(e) => setForm({ ...form, type: e.target.value })}>
            {TYPES.map((t) => <option key={t}>{t}</option>)}
          </select>
        </GF>
        <GF label="Payment Schedule">
          <select className="g-select" style={SEL} value={form.payment_schedual}
            onChange={(e) => setForm({ ...form, payment_schedual: e.target.value })}>
            {PAYMENT_SCHEDULES.map((p) => <option key={p}>{p}</option>)}
          </select>
        </GF>
        <GF label="Start Date">
          <input className="g-input" style={INP} type="date" value={form.start_date}
            onChange={(e) => setForm({ ...form, start_date: e.target.value })} />
        </GF>
        <GF label="End Date">
          <input className="g-input" style={INP} type="date" value={form.end_date}
            onChange={(e) => setForm({ ...form, end_date: e.target.value })} />
        </GF>
        {mode === "edit" && (
          <GF label="Status">
            <select className="g-select" style={SEL} value={form.status}
              onChange={(e) => setForm({ ...form, status: e.target.value })}>
              {STATUSES.map((s) => <option key={s}>{s}</option>)}
            </select>
          </GF>
        )}
        <GF label="Linked Invoices">
          <input className="g-input" style={INP} value={form.linked_invoices}
            onChange={(e) => setForm({ ...form, linked_invoices: e.target.value })}
            placeholder="LUL-060726, LUL-070826" />
        </GF>
      </div>

      <GF label="Deliverables">
        <textarea className="g-input"
          style={{ ...INP, minHeight: 80, resize: "vertical", fontFamily: FF }}
          value={form.deliverables}
          onChange={(e) => setForm({ ...form, deliverables: e.target.value })}
          placeholder="e.g. 1 × IG Reel, 30 days usage rights…" />
      </GF>
      <div style={{ marginTop: 14 }}>
        <GF label="Notes">
          <textarea className="g-input"
            style={{ ...INP, minHeight: 60, resize: "vertical", fontFamily: FF }}
            value={form.notes}
            onChange={(e) => setForm({ ...form, notes: e.target.value })}
            placeholder="Additional notes…" />
        </GF>
      </div>

      {/* Invoice preview */}
      {showPreview && (
        <div style={{ marginTop: 16, marginBottom: 16, ...subPanel, borderRadius: 14, overflow: "hidden" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "9px 13px", borderBottom: "0.5px solid rgba(255,255,255,0.5)", background: "rgba(255,255,255,0.3)" }}>
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="rgba(60,60,67,0.4)" strokeWidth="2" strokeLinecap="round">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
              <polyline points="14,2 14,8 20,8"/>
            </svg>
            <span style={{ fontSize: 10, fontWeight: 700, color: "rgba(60,60,67,0.42)", letterSpacing: "0.7px", textTransform: "uppercase" }}>
              Invoice Preview
            </span>
            <span style={{ marginLeft: "auto", fontSize: 10, fontWeight: 600, color: "rgba(60,60,67,0.5)", background: "rgba(255,255,255,0.55)", padding: "2px 8px", borderRadius: 20, border: "0.5px solid rgba(255,255,255,0.85)" }}>
              {numInv} invoice{numInv !== 1 ? "s" : ""}
            </span>
          </div>
          <div style={{ padding: "12px 13px", display: "flex", flexDirection: "column", gap: 7 }}>
            <PR label="Gross deal" value={`$${fmt(gross)}`} />
            {form.billed_to === "platform" && (
              <PR label="Platform fee (20%)" value={`−$${fmt(gross * 0.2)}`} vc="rgba(160,50,40,0.8)" />
            )}
            <PR label="Net to QC inc." value={`$${fmt(netC)}`} />
            <div style={{ height: "0.5px", background: "rgba(255,255,255,0.55)", margin: "2px 0" }} />
            <PR label="Per invoice · net" value={`$${fmt(netPer)}`} />
            <PR label="HST (13%)" value={`$${fmt(netPer * 0.13)}`} />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "rgba(255,255,255,0.55)", border: "0.5px solid rgba(255,255,255,0.85)", borderRadius: 9, padding: "9px 12px", marginTop: 2 }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: "rgba(60,60,67,0.55)" }}>Per invoice total</span>
              <span style={{ fontSize: 18, fontWeight: 700, color: "#1c1c1e", letterSpacing: "-0.5px" }}>${fmt(totalPer)}</span>
            </div>
          </div>
        </div>
      )}

      {/* Status message */}
      {statusMsg && (
        <div style={{
          display: "flex", alignItems: "center", gap: 8,
          padding: "10px 13px", borderRadius: 10, fontSize: 13, fontWeight: 500, marginBottom: 14,
          ...(statusMsg.type === "success"
            ? { background: "rgba(52,199,89,0.09)", color: "#1e7a3c", border: "1px solid rgba(52,199,89,0.2)" }
            : { background: "rgba(200,50,40,0.07)", color: "rgba(160,40,30,0.9)", border: "1px solid rgba(200,50,40,0.15)" }),
        }}>
          {statusMsg.type === "success"
            ? <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20,6 9,17 4,12"/></svg>
            : <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>}
          {statusMsg.msg}
        </div>
      )}

      <button
        className="submit-btn"
        onClick={onSubmit}
        disabled={loading}
        style={{
          width: "100%", padding: "12px",
          background: "rgba(20,22,30,0.88)",
          border: "none", borderRadius: 12,
          color: "white", fontSize: 15, fontWeight: 600,
          cursor: loading ? "not-allowed" : "pointer",
          letterSpacing: "-0.2px",
          transition: "opacity 0.15s, transform 0.15s",
          marginTop: 4,
          opacity: loading ? 0.5 : 1,
          fontFamily: FF,
        }}
      >
        {loading ? "Saving…" : mode === "edit" ? "Update Campaign" : "Create Campaign"}
      </button>
    </>
  );
}

const ITEMS_PER_PAGE = 10;

// ── Pagination bar ─────────────────────────────────────────────────────────────
function Pagination({ page, totalPages, onPage, totalItems, filtered }) {
  if (totalPages <= 1 && totalItems === filtered) return null;

  const pages = [];
  if (totalPages <= 6) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else if (page <= 3) {
    pages.push(1, 2, 3, 4, "…", totalPages);
  } else if (page >= totalPages - 2) {
    pages.push(1, "…", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
  } else {
    pages.push(1, "…", page - 1, page, page + 1, "…", totalPages);
  }

  const btn = (label, target, disabled, active) => (
    <button
      key={label}
      onClick={() => !disabled && onPage(target)}
      disabled={disabled}
      style={{
        minWidth: 30, height: 28, padding: "0 8px",
        borderRadius: 8,
        border: active ? "0.5px solid rgba(255,255,255,0.85)" : "0.5px solid transparent",
        background: active ? "rgba(255,255,255,0.65)" : "transparent",
        color: disabled ? "rgba(60,60,67,0.2)" : active ? "#1c1c1e" : "rgba(60,60,67,0.5)",
        fontSize: 12, fontWeight: active ? 600 : 400,
        cursor: disabled ? "not-allowed" : "pointer",
        fontFamily: FF, transition: "background 0.12s",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap" }}>
      {btn("←", page - 1, page === 1, false)}
      {pages.map((p, i) =>
        p === "…"
          ? <span key={`e${i}`} style={{ fontSize: 12, color: "rgba(60,60,67,0.3)", padding: "0 2px", fontFamily: FF }}>…</span>
          : btn(p, p, false, p === page)
      )}
      {btn("→", page + 1, page === totalPages, false)}
      <span style={{ marginLeft: 8, fontSize: 11, color: "rgba(60,60,67,0.35)", fontFamily: FF }}>
        {filtered} campaign{filtered !== 1 ? "s" : ""}
      </span>
    </div>
  );
}

// ── Main page ─────────────────────────────────────────────────────────────────
export default function CampaignPage() {
  const [tab, setTab]                   = useState("list");
  const [campaigns, setCampaigns]       = useState([]);
  const [fetchingCampaigns, setFetching] = useState(false);
  const [search, setSearch]             = useState("");
  const [page, setPage]                 = useState(1);

  // Edit tab
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [dropdownOpen, setDropdownOpen]           = useState(false);
  const [editSearch, setEditSearch]               = useState("");
  const dropdownRef = useRef(null);

  // Form
  const [form, setForm]         = useState(EMPTY_FORM);
  const [loading, setLoading]   = useState(false);
  const [statusMsg, setStatusMsg] = useState(null);

  useEffect(() => { fetchCampaigns(); }, []);

  useEffect(() => {
    const fn = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setDropdownOpen(false);
    };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);

  useEffect(() => {
    setStatusMsg(null);
    if (tab === "new") setForm(EMPTY_FORM);
  }, [tab]);

  useEffect(() => { setPage(1); }, [search]);

  const fetchCampaigns = async () => {
    setFetching(true);
    try {
      const r = await fetch(GET_CAMPAIGNS_URL);
      const d = await r.json();
      setCampaigns(Array.isArray(d) ? d : d.campaigns || []);
    } catch { setCampaigns([]); }
    finally { setFetching(false); }
  };

  const selectCampaign = (c) => {
    setSelectedCampaign(c);
    setForm({
      campaign_name:  c.campaign_name || "",
      brand:          c.brand || "",
      start_date:     c.start_date || "",
      end_date:       c.end_date || "",
      deal_amount:    c.deal_amount || "",
      type:           c.type || "one-off",
      payment_schedual: c.payment_schedual || "one-time",
      platform:       c.platform || "Instagram",
      deliverables:   c.deliverables || "",
      notes:          c.notes || "",
      status:         c.status || "active",
      billed_to:      c.billed_to || "platform",
      num_invoices:   c.num_invoices || "",
      linked_invoices: Array.isArray(c.linked_invoices)
        ? c.linked_invoices.join(", ")
        : c.linked_invoices || "",
    });
    setDropdownOpen(false);
    setEditSearch("");
  };

  const handleSubmit = async (mode) => {
    if (!form.campaign_name || !form.brand || !form.deal_amount) {
      setStatusMsg({ type: "error", msg: "Campaign name, brand and amount are required." });
      return;
    }
    setLoading(true); setStatusMsg(null);
    try {
      // Cast numeric fields — API requires numbers, not strings
      const base = {
        ...form,
        deal_amount:  Number(form.deal_amount)  || 0,
        num_invoices: form.num_invoices ? Number(form.num_invoices) : undefined,
      };
      const payload = mode === "edit" && selectedCampaign
        ? { ...base, campaign_id: selectedCampaign.campaign_id }
        : base;
      const r = await fetch(mode === "edit" ? UPDATE_URL : CREATE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (r.ok) {
        setStatusMsg({
          type: "success",
          msg: mode === "edit"
            ? `"${form.campaign_name}" updated.`
            : `"${form.campaign_name}" created.`,
        });
        fetchCampaigns();
        if (mode === "new") setForm(EMPTY_FORM);
      } else throw new Error();
    } catch {
      setStatusMsg({ type: "error", msg: "Failed to save. Check connection." });
    } finally { setLoading(false); }
  };

  // ── Computed ────────────────────────────────────────────────────────────────
  const totalRevenue = campaigns.reduce((s, c) => s + (Number(c.deal_amount) || 0), 0);
  const activeCount  = campaigns.filter((c) => c.status === "active").length;
  const paidCount    = campaigns.filter((c) => c.status === "awaiting_payment").length;
  const avgDeal      = campaigns.length > 0 ? totalRevenue / campaigns.length : 0;

  const STATUS_ORDER = { active: 0, awaiting_payment: 1, completed: 2 };
  const filtered = campaigns
    .filter((c) =>
      c.campaign_name?.toLowerCase().includes(search.toLowerCase()) ||
      c.brand?.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) => {
      const diff = (STATUS_ORDER[a.status] ?? 3) - (STATUS_ORDER[b.status] ?? 3);
      if (diff !== 0) return diff;
      return (Number(b.deal_amount) || 0) - (Number(a.deal_amount) || 0);
    });

  const totalPages = Math.max(1, Math.ceil(filtered.length / ITEMS_PER_PAGE));
  const safePage   = Math.min(page, totalPages);
  const paginated  = filtered.slice((safePage - 1) * ITEMS_PER_PAGE, safePage * ITEMS_PER_PAGE);

  const editFiltered = campaigns.filter((c) =>
    c.campaign_name?.toLowerCase().includes(editSearch.toLowerCase()) ||
    c.brand?.toLowerCase().includes(editSearch.toLowerCase())
  );

  const fmtCAD = (n) =>
    Number(n).toLocaleString("en-CA", { maximumFractionDigits: 0 });

  const fmtDate = (d) =>
    d ? new Date(d).toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric" }) : null;

  return (
    <div style={{ height: "calc(100vh - 24px)", display: "flex", flexDirection: "column", fontFamily: FF }}>
      <GlassCard style={{ maxWidth: "none", height: "100%", display: "flex", flexDirection: "column" }}>

        {/* ── Header (fixed) ───────────────────────────────────────────── */}
        <div style={{ padding: "22px 28px 16px", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
            <div style={{
              width: 36, height: 36, borderRadius: 10,
              background: "rgba(255,255,255,0.55)",
              border: "0.5px solid rgba(255,255,255,0.88)",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
                  stroke="rgba(50,60,90,0.6)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: 17, fontWeight: 700, color: "#1c1c1e", letterSpacing: "-0.4px" }}>
                Campaign Manager
              </div>
              <div style={{ fontSize: 11, color: "rgba(60,60,67,0.38)", marginTop: 1 }}>
                9456-1438 Québec inc.
              </div>
            </div>
            <button
              onClick={fetchCampaigns}
              disabled={fetchingCampaigns}
              style={{
                marginLeft: "auto",
                display: "flex", alignItems: "center", gap: 6,
                padding: "7px 13px", borderRadius: 10,
                background: "rgba(255,255,255,0.52)",
                border: "0.5px solid rgba(255,255,255,0.82)",
                color: "rgba(60,60,67,0.6)", fontSize: 12, fontWeight: 500,
                cursor: fetchingCampaigns ? "not-allowed" : "pointer",
                opacity: fetchingCampaigns ? 0.5 : 1, fontFamily: FF,
              }}
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
                style={{ animation: fetchingCampaigns ? "spin 1s linear infinite" : "none" }}>
                <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
                <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/>
              </svg>
              Refresh
            </button>
          </div>

          <TabBar
            tabs={[
              { id: "list",   label: "List" },
              { id: "new",    label: "New Campaign" },
              { id: "edit",   label: "Edit Campaign" },
            ]}
            active={tab}
            onChange={setTab}
          />
        </div>

        <div style={{ height: "0.5px", background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.65) 15%, rgba(255,255,255,0.65) 85%, transparent)", flexShrink: 0 }} />

        {/* ══ LIST TAB ═══════════════════════════════════════════════════ */}
        {tab === "list" && (
          <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>

            {/* Fixed: stats + search */}
            <div style={{ padding: "18px 28px 14px", flexShrink: 0 }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10, marginBottom: 16 }}>
                <StatCard
                  label="Total Campaigns"
                  value={fetchingCampaigns ? "—" : campaigns.length}
                  sub={`${activeCount} active`}
                />
                <StatCard
                  label="Awaiting Payment"
                  value={fetchingCampaigns ? "—" : paidCount}
                  sub={paidCount === 1 ? "invoice out" : "invoices out"}
                  accent="rgba(255,249,235,0.6)"
                />
                <StatCard
                  label="Total Revenue"
                  value={fetchingCampaigns ? "—" : `$${fmtCAD(totalRevenue)}`}
                  sub="gross deal value"
                  accent="rgba(240,252,244,0.65)"
                />
                <StatCard
                  label="Avg Deal Size"
                  value={fetchingCampaigns ? "—" : `$${fmtCAD(avgDeal)}`}
                  sub="per campaign"
                />
              </div>

              <div style={{ position: "relative" }}>
                <svg style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}
                  width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="rgba(60,60,67,0.35)" strokeWidth="2.2" strokeLinecap="round">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
                <input
                  className="g-input"
                  style={{ ...INP, paddingLeft: 34 }}
                  placeholder="Search by campaign or brand…"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            {/* Scrollable list */}
            <div style={{ flex: 1, overflowY: "auto", minHeight: 0, padding: "0 28px" }}>

              {fetchingCampaigns && <SkeletonRows count={6} height={62} />}
              {!fetchingCampaigns && filtered.length === 0 && (
                <div style={{ padding: "40px 0", textAlign: "center", color: "rgba(60,60,67,0.38)", fontSize: 14 }}>
                  {search ? "No campaigns match your search." : "No campaigns yet — create your first one."}
                </div>
              )}

              {!fetchingCampaigns && paginated.length > 0 && (
                <div style={{
                  background: "rgba(255,255,255,0.42)",
                  border: "0.5px solid rgba(255,255,255,0.78)",
                  borderRadius: 16,
                  overflow: "hidden",
                }}>
                  {paginated.map((c, idx) => {
                    const gross = Number(c.deal_amount) || 0;
                    const net   = c.billed_to === "platform" ? gross * 0.8 : gross;
                    const start = fmtDate(c.start_date);
                    const end   = fmtDate(c.end_date);
                    return (
                      <div
                        key={c.campaign_id || idx}
                        style={{
                          display: "flex", alignItems: "center", gap: 16,
                          padding: "14px 20px",
                          borderBottom: idx < paginated.length - 1
                            ? "0.5px solid rgba(255,255,255,0.55)"
                            : "none",
                          cursor: "pointer",
                          transition: "background 0.12s",
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.32)"}
                        onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                        onClick={() => { selectCampaign(c); setTab("edit"); }}
                      >
                        <div style={{
                          width: 7, height: 7, borderRadius: "50%", flexShrink: 0,
                          background: c.status === "active"
                            ? "rgba(52,199,89,0.75)"
                            : c.status === "awaiting_payment"
                            ? "rgba(255,149,0,0.65)"
                            : "rgba(60,60,67,0.2)",
                        }} />
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ display: "flex", alignItems: "baseline", gap: 8, marginBottom: 3, flexWrap: "wrap" }}>
                            <span style={{ fontSize: 14, fontWeight: 600, color: "#1c1c1e", letterSpacing: "-0.2px", fontFamily: FF }}>
                              {c.campaign_name}
                            </span>
                            <span style={{ fontSize: 12, color: "rgba(60,60,67,0.45)", fontFamily: FF }}>
                              {c.brand}
                            </span>
                          </div>
                          {(start || end) && (
                            <div style={{ fontSize: 11, color: "rgba(60,60,67,0.38)", fontFamily: FF }}>
                              {start}{end ? ` → ${end}` : ""}
                            </div>
                          )}
                        </div>
                        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", alignItems: "center" }}>
                          {c.platform && (
                            <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 8px", borderRadius: 20, background: "rgba(60,110,220,0.08)", color: "rgba(30,60,160,0.75)", border: "0.5px solid rgba(60,110,220,0.15)", fontFamily: FF, whiteSpace: "nowrap" }}>
                              {c.platform}
                            </span>
                          )}
                          {c.type && (
                            <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 8px", borderRadius: 20, background: "rgba(100,105,130,0.07)", color: "rgba(60,60,67,0.55)", border: "0.5px solid rgba(100,105,130,0.12)", fontFamily: FF, whiteSpace: "nowrap" }}>
                              {c.type}
                            </span>
                          )}
                          <SPill status={c.status} />
                        </div>
                        <div style={{ textAlign: "right", flexShrink: 0, minWidth: 72 }}>
                          <div style={{ fontSize: 15, fontWeight: 700, color: "#1c1c1e", letterSpacing: "-0.3px", fontFamily: FF }}>
                            ${fmtCAD(gross)}
                          </div>
                          {c.billed_to === "platform" && gross > 0 && (
                            <div style={{ fontSize: 10, color: "rgba(60,60,67,0.38)", fontFamily: FF }}>
                              ${fmtCAD(net)} net
                            </div>
                          )}
                        </div>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(60,60,67,0.28)" strokeWidth="2.2" strokeLinecap="round" style={{ flexShrink: 0 }}>
                          <polyline points="9,18 15,12 9,6"/>
                        </svg>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Fixed pagination footer */}
            {!fetchingCampaigns && filtered.length > 0 && (
              <div style={{
                padding: "12px 28px 18px",
                flexShrink: 0,
                borderTop: "0.5px solid rgba(255,255,255,0.55)",
                display: "flex", alignItems: "center", justifyContent: "space-between",
              }}>
                <Pagination
                  page={safePage}
                  totalPages={totalPages}
                  onPage={setPage}
                  totalItems={campaigns.length}
                  filtered={filtered.length}
                />
              </div>
            )}
          </div>
        )}

        {/* ══ NEW CAMPAIGN TAB ══════════════════════════════════════════ */}
        {tab === "new" && (
          <div style={{ flex: 1, overflowY: "auto", minHeight: 0, padding: "22px 28px 30px" }}>
            <FormBody
              form={form} setForm={setForm}
              mode="new"
              statusMsg={statusMsg}
              loading={loading}
              onSubmit={() => handleSubmit("new")}
            />
          </div>
        )}

        {/* ══ EDIT CAMPAIGN TAB ═════════════════════════════════════════ */}
        {tab === "edit" && (
          <div style={{ flex: 1, overflowY: "auto", minHeight: 0, padding: "22px 28px 30px" }}>

            {/* Dropdown selector */}
            <div ref={dropdownRef} style={{ position: "relative", marginBottom: 22 }}>
              <Lbl text="Select Campaign" />
              <div
                className="g-input"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                style={{
                  display: "flex", alignItems: "center", gap: 8,
                  padding: "11px 13px", ...INP, cursor: "pointer", marginTop: 6,
                  ...(dropdownOpen ? { borderColor: "rgba(255,255,255,0.95)" } : {}),
                }}
              >
                {selectedCampaign ? (
                  <>
                    <span style={{ fontWeight: 600, color: "#1c1c1e" }}>{selectedCampaign.brand}</span>
                    <span style={{ color: "rgba(60,60,67,0.3)" }}>—</span>
                    <span style={{ color: "#1c1c1e" }}>{selectedCampaign.campaign_name}</span>
                    <SPill status={selectedCampaign.status} />
                  </>
                ) : (
                  <span style={{ color: "rgba(60,60,67,0.28)" }}>Search campaigns…</span>
                )}
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
                  style={{ marginLeft: "auto", opacity: 0.3, flexShrink: 0, transform: dropdownOpen ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>
                  <polyline points="6,9 12,15 18,9"/>
                </svg>
              </div>

              {dropdownOpen && (
                <div style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, right: 0, background: "rgba(248,248,250,0.96)", backdropFilter: "blur(40px) saturate(180%)", WebkitBackdropFilter: "blur(40px) saturate(180%)", border: "0.5px solid rgba(255,255,255,0.9)", borderRadius: 14, overflow: "hidden", zIndex: 100 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 13px", borderBottom: "0.5px solid rgba(0,0,0,0.06)" }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(60,60,67,0.35)" strokeWidth="2.2" strokeLinecap="round">
                      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                    </svg>
                    <input className="g-input"
                      style={{ flex: 1, background: "none", border: "none", color: "#1c1c1e", fontSize: 13, outline: "none", fontFamily: FF, boxShadow: "none", padding: 0 }}
                      placeholder="Filter by name or brand…"
                      value={editSearch}
                      onChange={(e) => setEditSearch(e.target.value)}
                      autoFocus />
                  </div>
                  <div style={{ maxHeight: 260, overflowY: "auto", paddingBottom: 6 }}>
                    {fetchingCampaigns && (
                      <div style={{ padding: 16, color: "rgba(60,60,67,0.35)", fontSize: 13, textAlign: "center" }}>Loading…</div>
                    )}
                    {!fetchingCampaigns && editFiltered.length === 0 && (
                      <div style={{ padding: 16, color: "rgba(60,60,67,0.35)", fontSize: 13, textAlign: "center" }}>No campaigns found</div>
                    )}
                    {editFiltered.map((c) => (
                      <div key={c.campaign_id} className="drop-item"
                        onClick={() => selectCampaign(c)}
                        style={{ padding: "10px 13px", cursor: "pointer", borderBottom: "0.5px solid rgba(0,0,0,0.05)", transition: "background 0.12s", ...(selectedCampaign?.campaign_id === c.campaign_id ? { background: "rgba(0,0,0,0.04)" } : {}) }}>
                        <div style={{ fontSize: 13, fontWeight: 500, color: "#1c1c1e", marginBottom: 4 }}>{c.campaign_name}</div>
                        <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
                          <span style={{ fontSize: 11, color: "rgba(60,60,67,0.42)" }}>{c.brand}</span>
                          <SPill status={c.status} />
                          <span style={{ fontSize: 11, fontWeight: 600, color: "rgba(60,60,67,0.65)", marginLeft: "auto" }}>
                            ${Number(c.deal_amount).toLocaleString()}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {selectedCampaign ? (
              <>
                {/* Invoice recalculation notice */}
                {(() => {
                  const orig = selectedCampaign;
                  const dealChanged    = String(form.deal_amount)  !== String(orig.deal_amount  || "");
                  const invChanged     = String(form.num_invoices) !== String(orig.num_invoices || "");
                  const billedChanged  = form.billed_to !== (orig.billed_to || "platform");
                  const willRecalc     = dealChanged || invChanged || billedChanged;

                  const origNum  = Number(orig.num_invoices) || 0;
                  const newNum   = Number(form.num_invoices) || 0;
                  const invDiff  = newNum - origNum;

                  if (!willRecalc) return null;
                  return (
                    <div style={{
                      display: "flex", gap: 10, alignItems: "flex-start",
                      padding: "11px 14px", marginBottom: 18, borderRadius: 11,
                      background: "rgba(255,149,0,0.07)",
                      border: "0.5px solid rgba(255,149,0,0.22)",
                    }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(180,100,0,0.8)" strokeWidth="2" strokeLinecap="round" style={{ marginTop: 1, flexShrink: 0 }}>
                        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                        <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                      </svg>
                      <div style={{ fontSize: 12, color: "rgba(120,60,0,0.85)", fontFamily: FF, lineHeight: 1.5 }}>
                        <strong>Draft invoices will be recalculated</strong>
                        {invDiff > 0 && ` · ${invDiff} new draft${invDiff > 1 ? "s" : ""} will be created`}
                        {invDiff < 0 && ` · ${Math.abs(invDiff)} draft${Math.abs(invDiff) > 1 ? "s" : ""} will be deleted`}
                        {" · Billed invoices are never modified."}
                      </div>
                    </div>
                  );
                })()}

                <FormBody
                  form={form} setForm={setForm}
                  mode="edit"
                  statusMsg={statusMsg}
                  loading={loading}
                  onSubmit={() => handleSubmit("edit")}
                />
              </>
            ) : (
              <div style={{ padding: "40px 0", textAlign: "center", color: "rgba(60,60,67,0.35)", fontSize: 14, fontFamily: FF }}>
                Select a campaign above to edit it.
              </div>
            )}
          </div>
        )}

      </GlassCard>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
